module.exports = __webpack_public_path__ + "img/expensive-day.cc860e94.png";